import { Component, Inject, OnInit } from "@angular/core";
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from "@angular/material/bottom-sheet";

@Component({
  selector: "app-prompt-component",
  templateUrl: "./prompt.component.html",
  styleUrls: ["./prompt.component.scss"],
})
export class PromptComponent implements OnInit {
  downloadLink: string = "";

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: { mobileType: "ios" | "android"; promptEvent?: any },
    private bottomSheetRef: MatBottomSheetRef<PromptComponent>
  ) {
    this.downloadLink =
      data.mobileType === "ios"
        ? "https://apps.apple.com/app/brain-changer-app/id1628379377"
        : "https://play.google.com/store/apps/details?id=brain.changer.project&pcampaignid=website_prompt";
  }

  public installPwa(): void {
    this.data.promptEvent.prompt();
    this.close();
  }

  public close() {
    this.bottomSheetRef.dismiss();
  }

  ngOnInit() {
    console.log(this.data);
  }
}
